import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Box
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { fetchAsyncAddPricing } from "redux/pricingSlice";
import { fetchAsyncUpdatePricing } from "redux/pricingSlice";

const PricingForm = ({ openModel, closeModel, editData, isEdit, refreshList }) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    userLimit: 0
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (isEdit && editData) {

      setFormData({
        name: editData?.name,
        description:editData?.dec,
        userLimit: editData?.uLmt
      });
    }
  }, [isEdit, editData]);

  const toCamelCase = (value) => {
    return value
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

   
    formattedValue = toCamelCase(value);
   
    setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
    }));
    
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Pricing Name is required';
    
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleAddPricing = () => {
    dispatch(fetchAsyncAddPricing(formData))
      .then((res) => {
        if (res?.payload) {
          refreshList();
          closeModel();
          addToast(`New Pricing has been created successfully!`, { appearance: "success" });
        }
        else{
          const msg = res?.error?.message || "Error creating pricing"
          addToast(msg, { appearance: "error" });
        }
      })
      .catch((err) => {
        addToast("Error creating pricing", { appearance: "error" });
      });
  };

  const handleEditPricing = () => {
    dispatch(fetchAsyncUpdatePricing({ id: editData._id, editData: formData }))
      .then((res) => {
        if (res?.payload) {
          refreshList();
          closeModel();
          addToast(`Pricing details have been updated successfully!`, { appearance: "success" });
        }
        else{
          const msg = res?.error?.message || "Error updating pricing"
          addToast(msg, { appearance: "error" });

        }
      })
      .catch((err) => {
        addToast("Error updating pricing", { appearance: "error" });
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      if (!isEdit) {
        handleAddPricing();
      } 
      else{
        handleEditPricing()
      }
    }
  };

  const finalRef = useRef(null);

  const userLimitOptions = [
    {label:'Select Limit', value:0},
    {label:'5', value:5},
    {label:'10', value:10},
    {label:'20', value:20},
    {label:'25', value:25}

  ]
  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={openModel}
        onClose={closeModel}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent
        top="0" 
        margin="0 auto" 
        maxH="-webkit-max-content"
        // bottom="0"
        className="add-form-modal-content"
        >
           <div className="fixed-header">
            <ModalHeader className="modal-heading expense-modal-header">
              {isEdit ? "Edit" : "Add"} Pricing Type
            </ModalHeader>
            <ModalCloseButton />
          </div>
          <ModalCloseButton />
          <ModalBody>
            <Form className="addForm">
            <div className="form-card">
              <Row>
                <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label><span className="span-star">Pricing Name*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter pricing Name"
                      value={formData?.name}
                      name='name'
                      isInvalid={!!errors?.name}
                      onChange={handleOnChange}
                    />
                  </Box>
                  <p className="form_error">{errors?.name}</p>
                </Col>
                <Col>
                
                  <Box display="flex" className="input-box">
                    <Form.Label>User Limit</Form.Label>
                    <Form.Select
                    name="userLimit"
                    value={formData?.userLimit}
                    onChange={handleOnChange}
                  
                >
                  {userLimitOptions?.map((item) => {
                    return <option value={item?.value}>{item?.label}</option>;
                  })}
                </Form.Select>
                  </Box>
                </Col>
              </Row>
              </div>
              <Row>
              <Col>
                  <Box display="flex" className="input-box">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="description"
                      placeholder="Type Here..."
                      value={formData.description}
                      onChange={handleOnChange}
                    />
                  </Box>
                </Col>
              </Row>
              <Row className="role_add_btn">
                <Button
                  variant="brand"
                  type="submit"
                  className="submit-btn mt-1 px-4"
                  onClick={(e)=>handleSubmit(e)}
                >
                  Submit
                </Button>
              </Row>
            </Form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PricingForm;